import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCondicionPago = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'condicion_pago',
        name: 'Condicion de Pago',
        component: ViewCondicionPago,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
